"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldSkipNextInput = exports.clearNavigationTimeouts = exports.clearInputState = void 0;
const scrollable_1 = require("../../../components/scrollable");
const types_1 = require("../../../types");
const focusManager_1 = require("../focusManager");
const triggerInput_1 = require("./triggerInput");
const directionalInput_1 = require("./directionalInput");
const input_processors_1 = require("../../input/input-processors");
const aButtonInput_1 = require("./aButtonInput");
/*
    Timeouts
*/
const clearInputState = () => {
    (0, exports.clearNavigationTimeouts)();
    (0, input_processors_1.clearLongHoldTimeouts)();
    (0, directionalInput_1.clearDirectionalInputStack)();
    (0, aButtonInput_1.clearAButtonInputStack)();
};
exports.clearInputState = clearInputState;
const clearNavigationTimeouts = () => {
    (0, triggerInput_1.clearTriggerRepeatInterval)();
    (0, directionalInput_1.clearDirectionRepeats)();
};
exports.clearNavigationTimeouts = clearNavigationTimeouts;
/**
 * Determines, given the last input mode and currently focused element, if we should skip the next
 * navigate action. When we are in the middle of a large body of text, or a scrollable interactable, we
 * don't want to user to have to navigate twice in order for input to start registering.
 *
 *  @param previousInputMode - the input mode before
 *
 *  @returns whether we should immediately start navigating
 */
const shouldSkipNextInput = (previousInputMode) => {
    const previousInputModeWasFocusDriven = (0, types_1.isFocusDriven)(previousInputMode);
    const currentlyFocusedInteractable = (0, focusManager_1.getCurrentlyFocusedInteractable)();
    if (previousInputMode === types_1.DetailedInputMode.PassiveMouse) {
        return false;
    }
    if (previousInputModeWasFocusDriven) {
        return false;
    }
    if (currentlyFocusedInteractable && (0, scrollable_1.isScrollable)(currentlyFocusedInteractable)) {
        return false;
    }
    return true;
};
exports.shouldSkipNextInput = shouldSkipNextInput;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvcmUvbWFuYWdlcnMvaW5wdXQtbWFuYWdlci9jb21tb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELCtEQUE4RDtBQUM5RCwwQ0FBa0U7QUFDbEUsa0RBQWtFO0FBQ2xFLGlEQUE0RDtBQUM1RCx5REFBdUY7QUFDdkYsbUVBQXFFO0FBQ3JFLGlEQUF3RDtBQUV4RDs7RUFFRTtBQUVLLE1BQU0sZUFBZSxHQUFHLEdBQUcsRUFBRTtJQUNoQyxJQUFBLCtCQUF1QixHQUFFLENBQUM7SUFDMUIsSUFBQSx3Q0FBcUIsR0FBRSxDQUFDO0lBQ3hCLElBQUEsNkNBQTBCLEdBQUUsQ0FBQztJQUM3QixJQUFBLHFDQUFzQixHQUFFLENBQUM7QUFDN0IsQ0FBQyxDQUFDO0FBTFcsUUFBQSxlQUFlLG1CQUsxQjtBQUVLLE1BQU0sdUJBQXVCLEdBQUcsR0FBRyxFQUFFO0lBQ3hDLElBQUEseUNBQTBCLEdBQUUsQ0FBQztJQUM3QixJQUFBLHdDQUFxQixHQUFFLENBQUM7QUFDNUIsQ0FBQyxDQUFDO0FBSFcsUUFBQSx1QkFBdUIsMkJBR2xDO0FBRUY7Ozs7Ozs7O0dBUUc7QUFDSSxNQUFNLG1CQUFtQixHQUFHLENBQUMsaUJBQW9DLEVBQVcsRUFBRTtJQUNqRixNQUFNLCtCQUErQixHQUFHLElBQUEscUJBQWEsRUFBQyxpQkFBaUIsQ0FBQyxDQUFDO0lBQ3pFLE1BQU0sNEJBQTRCLEdBQUcsSUFBQSw4Q0FBK0IsR0FBRSxDQUFDO0lBRXZFLElBQUksaUJBQWlCLEtBQUsseUJBQWlCLENBQUMsWUFBWSxFQUFFLENBQUM7UUFDdkQsT0FBTyxLQUFLLENBQUM7SUFDakIsQ0FBQztJQUVELElBQUksK0JBQStCLEVBQUUsQ0FBQztRQUNsQyxPQUFPLEtBQUssQ0FBQztJQUNqQixDQUFDO0lBRUQsSUFBSSw0QkFBNEIsSUFBSSxJQUFBLHlCQUFZLEVBQUMsNEJBQTRCLENBQUMsRUFBRSxDQUFDO1FBQzdFLE9BQU8sS0FBSyxDQUFDO0lBQ2pCLENBQUM7SUFFRCxPQUFPLElBQUksQ0FBQztBQUNoQixDQUFDLENBQUM7QUFqQlcsUUFBQSxtQkFBbUIsdUJBaUI5QiJ9